import { COMMA, ENTER } from "@angular/cdk/keycodes";
import { Component, Input, OnInit, Renderer2 } from "@angular/core";
import { MatChipInputEvent } from "@angular/material/chips";
import { DateAdapter } from "@angular/material/core";
import { ActivatedRoute, Router } from "@angular/router";
import {
  AlertController,
  LoadingController,
  ModalController,
} from "@ionic/angular";
import { Storage } from "@ionic/storage";
import { STORAGE } from "src/app/constant/storages";
import { ApiserviceService } from "src/app/httpservice/apiservice.service";
import { AppService } from "src/app/services/app.service";
import { errMsg } from "src/app/text_control/error-msg";
import { _getStorage } from "src/app/utils/local-storage";
import { BTN } from "../../../text_control/text_button";
import { DateFormat } from "../../report/setdate";
import { ModalSaveDraftNoTaxinvoiceComponent } from "../modal-save-draft-no-taxinvoice/modal-save-draft-no-taxinvoice.component";
import { ModalsaveNoTaxinvoiceComponent } from "../modalsave-no-taxinvoice/modalsave-no-taxinvoice.component";
var moment = require("moment");

export interface Fruit {
  abb: string;
}
@Component({
  selector: "app-check-no-taxinvoice",
  templateUrl: "./check-no-taxinvoice.component.html",
  styleUrls: ["./check-no-taxinvoice.component.scss"],
  providers: [{ provide: DateAdapter, useClass: DateFormat }],
})
export class CheckNoTaxinvoiceComponent implements OnInit {
  @Input() public appAutoFocus: boolean;
  showtable = false;
  datacustomer: any = [];
  dataaddress: any;
  radio_group = "";
  datalist: any = {};
  datatest = [];
  showbtn = true;
  showbranch = true;
  addr_info = "";
  dataitem: any;
  showinputremark = false;
  remark: any = "";
  showOderNo = false;
  orderNo: any = "";
  textBTN: any;
  receiptDate: Date = new Date();
  today: Date = new Date();
  userID = "";
  userBu = "";
  userLoc = "";
  userRole = "";
  userSource = "";

  listPriority = [];
  visible = true;
  selectable = true;
  removable = true;
  addOnBlur = true;
  readonly separatorKeysCodes: number[] = [ENTER, COMMA];
  fruits: Fruit[] = [];
  headerNewService: any;
  is_saveDraft = false;

  constructor(
    public modalController: ModalController,
    public storage: Storage,
    private appService: AppService,
    public apiservice: ApiserviceService,
    private router: ActivatedRoute,
    public alertController: AlertController,
    public loadingController: LoadingController,
    public route: Router,
    private renderer: Renderer2,
    private dateAdapter: DateAdapter<Date>
  ) {
    this.userID = _getStorage(STORAGE.userID);
    this.userRole = _getStorage(STORAGE.userRole);
    this.userBu = _getStorage(STORAGE.userBu);
    this.userLoc = _getStorage(STORAGE.userLoc);
    this.userSource = _getStorage(STORAGE.SOURCE_SYSTEM);
    this.textBTN = BTN;
    this.dataitem = _getStorage(STORAGE.DATA_ADD_NO__TAXINVOICE);
    this.addr_info =
      this.dataitem.address_detail[0].type_addr === "1"
        ? this.dataitem.address_detail[0].addr_info
        : this.dataitem.address_detail[0].addr_infoEN;
    dateAdapter.setLocale("en-GB");
  }

  ngOnInit() {}

  checkremark(e) {
    console.log("event remark....", e);
    this.remark = "";
    e.detail.checked == true
      ? (this.showinputremark = true)
      : (this.showinputremark = false);
  }

  gotoback() {
    this.route.navigate(["/select-no-taxinvoice"], {
      queryParams: { noName: "no_tax", selectedIndex: "4" },
    });
  }

  getSortPriority() {
    const req = {
      bu: this.userBu,
      loc: this.userLoc,
    };

    this.apiservice
      ._post(this.apiservice.apiUrl + this.apiservice.getSortPriority, req)
      .then((res) => {
        console.log("RES GET SORT PRIORITY =======:: ", res);
        if (res.statusCode === 200) {
          this.listPriority = res.data;
        }
      });
  }

  async modalDraft() {
    const modal = await this.modalController.create({
      component: ModalSaveDraftNoTaxinvoiceComponent,
      cssClass: "my-custom-draft",
      componentProps: {
        company_name: this.dataitem.buyer_company_name,
        buyer_id: this.dataitem.buyer_id,
      },
    });
    console.log("dafda", modal);

    modal.onDidDismiss().then(async () => {});
    return await modal.present();
  }

  async presentModal() {
    this.appService.setActive(4);

    const modal = await this.modalController.create({
      component: ModalsaveNoTaxinvoiceComponent,
      cssClass: "my-custom-class",
      componentProps: {
        data: this.numberABB,
        tpno: this.tpno === "0" ? true : false,
        buyer_id: this.dataitem.buyer_id,
        email:
          this.dataitem.buyer_type === "1"
            ? ""
            : this.dataitem.address_detail[0].email,
        remark: this.remark,
        orderNo: this.orderNo,
        newService: this.headerNewService,
        receipt_date: moment(this.receiptDate).format("YYYY-MM-DD"),
      },
    });
    console.log("dafda", modal);

    modal.onDidDismiss().then(async () => {
      // this.appService.setActive(5);
    });
    return await modal.present();
  }

  ionViewDidEnter() {
    this.is_saveDraft = false;
    this.checkfrut();
    this.showtable = false;
    this.datasalesTicket = [];
    this.fruits = [];
    this.appService.setActive(3);
    this.getSortPriority();
    setTimeout(() => {
      var elem = this.renderer.selectRootElement("#myInput");
      this.renderer.listen(elem, "focus", () => {});
      this.renderer.listen(elem, "blur", () => {});
      elem.focus();
    }, 100);
  }

  searchABB: any = "";
  data_searchABB: any;
  data_total: any;
  datasalesTicket: any;
  numberABB: any;
  tpno = "0";
  count = 0;
  numberABB2: any = [];
  async search_ABB() {
    let isConfirm = false;
    let numberABB: any = [];
    let numberABB2 = [];
    let numberABB1: any = [];
    let temp_no: any;
    let tpno: boolean;
    for (let i of this.fruits) {
      numberABB.push(i.abb);
    }

    try {
      numberABB.forEach((i) => {
        if (i.indexOf("-") > -1) {
          numberABB2.push(
            `${Number(i.split("-")[0])}-${
              this.userBu.toUpperCase() == "PWB"
                ? i.split("-")[1].padStart(9, "0")
                : i.split("-")[1].padStart(6, "0")
            }`
          );
        } else {
          numberABB2.push(i);
        }
      });

      if (!isConfirm) {
        if (this.searchABB === "") {
          const alert = await this.alertController.create({
            cssClass: "my-custom-class",
            message: "กรุณาระบุเลขที่ใบเสร็จรับเงิน/ใบกำกับภาษีอย่างย่อ",
            buttons: [
              {
                text: "OK",
                cssClass: "alertButton",
                handler: (blah) => {},
              },
            ],
          });
          await alert.present();
          // setTimeout(() => {
          //   alert.dismiss(true);
          // }, 2000);
        } else {
          if (numberABB2.length > 10) {
            const alert = await this.alertController.create({
              cssClass: "my-custom-class",
              message:
                "สามารถค้นหาใบเสร็จรับเงินและใบกำกับภาษีอย่างย่อได้ครั้งละ 10 รายการ",
              buttons: [
                {
                  text: "OK",
                  cssClass: "alertButton",
                  handler: (blah) => {
                    numberABB = numberABB.splice(0, 10);
                    this.fruits = this.fruits.slice(0, 10);
                  },
                },
              ],
            });
            await alert.present();
          } else {
            isConfirm = true;
          }
        }
      }
    } catch (error) {
      const alert = await this.alertController.create({
        cssClass: "my-custom-class",
        message: "รูปแบบใบเสร็จรับเงิน/ใบกำกับภาษีอย่างย่อไม่ถูกต้อง",
        buttons: [
          {
            text: "OK",
            cssClass: "alertButton",
            handler: (blah) => {
              this.datasalesTicket = [];
              this.showtable = false;
              this.fruits = [];
              this.showbtn = true;
            },
          },
        ],
      });
      await alert.present();
    }

    this.numberABB = numberABB2;

    if (isConfirm) {
      let data = {
        searchABB: {
          bu: this.userBu,
          userid: this.userID,
          loc: this.userLoc,
          userSource: this.userSource,
          receiptno: numberABB2,
          tpno: this.tpno === "0" ? true : false,
          type: "",
          receipt_date: this.receiptDate
            ? moment(this.receiptDate).format("YYYY-MM-DD")
            : moment().format("YYYY-MM-DD"),
        },
      };

      console.log("req data searchABB ========:: ", data);
      for await (const [index, item] of this.listPriority.entries()) {
        const header = {
          source_connection: item?.source_connection_id,
        };

        console.log("HEADER GET ABB ========:: ", header);
        const res = await this.apiservice._post(
          this.apiservice.apiUrl + this.apiservice.getABB,
          data,
          header
        );
        this.data_searchABB = res;
        if (res.statusCode === 200) {
          this.headerNewService = header;
          this.showtable = true;
          this.datasalesTicket = this.data_searchABB.data;
          return;
        } else if (res.statusCode === 204) {
          if (this.listPriority.length === index + 1) {
            // this.is_saveDraft = true;
            const alert = await this.alertController.create({
              cssClass: "my-custom-class",
              message: res.statusMessage,
              buttons: [
                {
                  text: "OK",
                  cssClass: "alertButton",
                  handler: (blah) => {
                    // this.datasalesTicket = [];
                    if (res.data[0].hasOwnProperty("errorData")) {
                      const index = this.numberABB.findIndex(
                        (find) => String(find) === String(res.data[0].errorData)
                      );
                      if (index > -1) {
                        this.fruits.splice(index, 1);

                        if (
                          this.fruits.length === 0 ||
                          String(this.fruits) === ""
                        ) {
                          this.showbtn = true;
                        } else {
                          this.showbtn = false;
                        }
                      }
                    }
                  },
                },
              ],
            });
            await alert.present();
          }
        } else {
          this.ErrorMsg(res.statusMessage);
          return
        }
      }
    }
  }

  newService(data) {
    const header = {
      rtsnewservice: "rts-new-service",
    };
    this.apiservice
      ._post(this.apiservice.apiUrl + this.apiservice.getABB, data, header)
      .then(async (res: any) => {
        this.data_searchABB = res;
        if (res.statusCode === 200) {
          this.headerNewService = header;
          this.showtable = true;
          this.showtable = true;
          this.datasalesTicket = this.data_searchABB.data;
        } else if (res.statusCode === 204) {
          // this.is_saveDraft = true;
          const alert = await this.alertController.create({
            cssClass: "my-custom-class",
            message: res.statusMessage,
            buttons: [
              {
                text: "OK",
                cssClass: "alertButton",
                handler: (blah) => {
                  // this.datasalesTicket = [];
                  if (res.data[0].hasOwnProperty("errorData")) {
                    const index = this.numberABB.findIndex(
                      (find) => String(find) === String(res.data[0].errorData)
                    );
                    if (index > -1) {
                      this.fruits.splice(index, 1);

                      if (
                        this.fruits.length === 0 ||
                        String(this.fruits) === ""
                      ) {
                        this.showbtn = true;
                      } else {
                        this.showbtn = false;
                      }
                    }
                  }
                },
              },
            ],
          });
          await alert.present();
        } else {
          this.ErrorMsg(res.statusMessage);
        }
      });
  }

  async ErrorMsg(message: string) {
    let alert = await this.alertController.create({
      cssClass: "my-custom-class",
      message: message,
      buttons: [
        {
          text: "OK",
          cssClass: "alertButton",
        },
      ],
    });
    await alert.present();
  }

  async delitem(post, i) {
    let abb = this.fruits;
    const alert = await this.alertController.create({
      cssClass: "my-confirm-phone",
      message: "ต้องการลบรายการนี้ใช่หรือไม่",
      buttons: [
        {
          text: "ยกเลิก",
          role: "cancel",
          cssClass: "alertCancel",
          handler: (blah) => {},
        },
        {
          text: "ยืนยัน",
          cssClass: "alertCancel",
          handler: () => {
            // console.log("Confirm Okay", post);
            const checkReceipt = post.salesTicket[0].receiptNo;
            const tpno = post.salesTicket[0].tpNo;
            let item = [];
            item = this.datasalesTicket;
            let index1 = this.datasalesTicket.indexOf(post);
            const index = this.numberABB.findIndex(
              (find) =>
                String(find) === String(checkReceipt) ||
                String(find) === String(tpno)
              // console.log('[------String(find.abb)--------]',(find) )
            );

            if (index > -1 || index1 > -1) {
              this.numberABB.splice(index1, 1);
              this.fruits.splice(index, 1);
              this.datasalesTicket.splice(index1, 1);
              console.log("this.fruits", this.fruits);
              if (this.fruits.length === 0 || String(this.fruits) === "") {
                this.showbtn = true;
              } else {
                this.showbtn = false;
              }
              // this.checkfruts()
            }
            if (item.length < 1) {
              this.showtable = false;
            }
          },
        },
      ],
    });
    await alert.present();
  }
  async checkbtn(e) {
    this.searchABB = e.target.value.match(/[0-9,-]*/);
    if (e.target.value.length > 1 || e.key === "Enter") {
      this.showbtn = false;
    } else {
      this.showbtn = true;
    }
    this.addDataAbb();
  }

  async addDataAbb() {
    if (this.showOderNo === true) {
      console.log("this.fruits======:: ", this.fruits);
      if (this.fruits.length > 1) {
        const alert = await this.alertController.create({
          cssClass: "my-custom-class",
          message: errMsg.errorLengthAbbOderNo,
          buttons: [
            {
              text: "OK",
              cssClass: "alertButton",
              handler: (blah) => {
                this.fruits = this.fruits.splice(0, 1);
                this.fruits = this.fruits.slice(0, 1);
              },
            },
          ],
        });
        await alert.present();
      }
    } else {
      if (this.fruits.length > 10) {
        const alert = await this.alertController.create({
          cssClass: "my-custom-class",
          message: errMsg.errorLengthAbb,
          buttons: [
            {
              text: "OK",
              cssClass: "alertButton",
              handler: (blah) => {
                this.fruits = this.fruits.splice(0, 10);
                this.fruits = this.fruits.slice(0, 10);
              },
            },
          ],
        });
        await alert.present();
      }
    }
  }

  add(e: MatChipInputEvent): void {
    const input = e.input;
    const value = e.value;
    // Add our fruit
    if (value.trim()) {
      const isAlreadyHave = this.fruits.find(
        (item) => item.abb == value.trim()
      );
      if (!isAlreadyHave) {
        this.fruits.push({ abb: value.trim() });
      }
    }
    this.addDataAbb();

    // Reset the input value
    if (input) {
      input.value = "";
    }
  }

  remove(fruit: Fruit): void {
    let abb: any = fruit;
    console.log("truit.....", fruit, this.datasalesTicket);
    let data = [];
    let databarcode: String = fruit.abb;
    data = this.datasalesTicket;
    console.log("data remove  abb barcode", data);

    if (databarcode.length > 16) {
      const index2 = this.fruits.indexOf(fruit);
      if (index2 > -1) {
        this.fruits.splice(index2, 1);

        if (this.fruits.length === 0 || String(this.fruits) === "") {
          this.showbtn = true;
          this.showtable = false;
        } else {
          this.showbtn = false;
        }
      }
      if (this.datasalesTicket.length > 0) {
        const index1 = this.numberABB.findIndex((i) => i === fruit.abb);
        const index = this.datasalesTicket[0].salesTicket.findIndex(
          (i) => i.barcodeComplete === fruit.abb
        );

        if (index > -1) {
          this.numberABB.splice(index1, 1);
          this.fruits.splice(index, 1);
          this.datasalesTicket.splice(index, 1);
          if (this.fruits.length === 0 || String(this.fruits) === "") {
            this.showbtn = true;
            this.showtable = false;
          } else {
            this.showbtn = false;
          }
        }
      }
    } else if (
      data !== undefined &&
      data.length > 0 &&
      this.numberABB.length > 0
    ) {
      try {
        let temp_no: any = fruit.abb.split("-");
        let Abb: any = temp_no[0] + "-" + temp_no[1].padStart(6, "0");

        this.checkfruts(abb);
        const index1 = this.numberABB.findIndex((i) => i === Abb);
        const index = this.datasalesTicket[0].salesTicket.findIndex(
          (i) =>
            i.tpNo === Abb || i.receiptNo === Abb || i.barcodeComplete === Abb
        );

        if (index > -1 || index1 > -1) {
          this.numberABB.splice(index1, 1);
          this.fruits.splice(index, 1);

          this.checkfrut();

          this.datasalesTicket.splice(index, 1);
          if (this.fruits.length === 0 || String(this.fruits) === "") {
            this.showbtn = true;
            this.showtable = false;
          } else {
            this.showbtn = false;
          }
        }
      } catch {
        const index = this.fruits.indexOf(fruit);
        if (index > -1) {
          this.fruits.splice(index, 1);
        }
      }
    } else {
      const index = this.fruits.indexOf(fruit);
      if (index > -1) {
        this.fruits.splice(index, 1);

        if (this.fruits.length === 0 || String(this.fruits) === "") {
          this.showbtn = true;
          this.showtable = false;
        } else {
          this.showbtn = false;
        }
      }
    }
  }

  checkfruts(abb) {
    if (this.fruits.length > 1) {
      console.log("fruits...........", this.fruits);
      const index = this.fruits.findIndex((i) => i === abb);
      if (index > -1) {
        this.fruits.splice(index, 1);

        this.checkfrut();
      }
      this.showbtn = false;
    } else {
      this.showbtn = true;
    }
  }

  checkfrut() {
    if (this.fruits.length > 1) {
      this.showbtn = false;
    } else {
      this.showbtn = true;
    }
  }

  formatnumber(data) {
    return data.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
  }

  Abbnumber(data: any) {
    let temp_no: any = data;
    if (temp_no) {
      temp_no = data.split("-");
      return temp_no[0] + "-" + temp_no[1].padStart(6, "0");
    }
  }

  checkOderNo(e) {
    this.orderNo = "";
    this.fruits = [];
    e.detail.checked == true
      ? (this.showOderNo = true)
      : (this.showOderNo = false);
  }
}
